import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mobile",
  "use": "mobile-usage",
  "viewBox": "0 0 9 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 14\" id=\"mobile\"><path fill-rule=\"evenodd\" d=\"M7 0H2a2 2 0 0 0-2 2v10c0 1 1 2 2 2h5c1 0 2-1 2-2V2c0-1-1-2-2-2M5.6 13H3.3c-.2 0-.3-.2-.3-.5s.1-.5.3-.5h2.4c.2 0 .3.2.3.5s-.1.5-.3.5ZM2 2h5v9H2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol